import {
  SHButton,
  SHDialog,
  SHStack,
  SHTypography,
} from "@components/design-systems";
import { RootState } from "@redux/store";
import { useSelector } from "react-redux";

interface OverwriteFilterDialogProps {
  onClose?: () => void;
  onSubmit?: () => void;
}

export const OverwriteFilterDialog = ({
  onClose,
  onSubmit,
}: OverwriteFilterDialogProps) => {
  const isSaving = useSelector(
    (state: RootState) =>
      state.modelScreener.ui.isSavingModelScreenerFilterSetting,
  );

  return (
    <SHDialog
      open
      disableEscapeKeyDown
      disableBackdropClick
      maxWidth={false}
      sx={{
        "& .MuiPaper-root": {
          width: { xs: "100%", md: 550 },
        },
      }}
      header="Overwrite the existing filter?"
      body={
        <SHStack spacing={"25px"}>
          <SHTypography variant="body2" sx={{ fontSize: "16px" }}>
            This name already exists. Overwrite existing filter?
          </SHTypography>
        </SHStack>
      }
      footer={
        <SHStack
          justifyContent="center"
          alignItems="center"
          direction={"row"}
          spacing={7}
        >
          <SHButton
            color="secondary"
            variant="text"
            size="extraMedium"
            onClick={onClose}
            disabled={isSaving}
          >
            No, I'll change the name
          </SHButton>
          <SHButton
            color="primary"
            size="extraMedium"
            variant="contained"
            onClick={onSubmit}
            disabled={isSaving}
            isLoading={isSaving}
          >
            Yes, overwrite it
          </SHButton>
        </SHStack>
      }
    />
  );
};
